import { useRef, useState } from "react";
import { api } from "../services/api";
import ImageCropper from "./ImageCropper";
import ClearImageButton from "./ClearImageButton";

const MIN_SIZE = 158;

const AvatarUpload = ({ onImageChange, currentImage }) => {
  const fileInputRef = useRef(null);
  const [selectedImageSrc, setSelectedImageSrc] = useState(null);
  const [isCropping, setIsCropping] = useState(false);
  const [isUploading, setIsUploading] = useState(false);

  const handleFileSelect = async (event) => {
    const file = event.target.files[0];
    console.log(
      "[AvatarUpload] file selected",
      file?.name,
      file?.type,
      file?.size
    );
    if (file) {
      try {
        const reader = new FileReader();
        reader.onload = (e) => {
          const dataUrl = e.target.result;
          const img = new Image();
          img.onload = () => {
            console.log(
              "[AvatarUpload] selected image size",
              img.naturalWidth,
              img.naturalHeight
            );
            if (img.naturalWidth < MIN_SIZE || img.naturalHeight < MIN_SIZE) {
              alert(
                `Минимальный размер изображения ${MIN_SIZE}x${MIN_SIZE} пикселей.`
              );
              if (fileInputRef.current) fileInputRef.current.value = "";
              return;
            }
            console.log(
              "[AvatarUpload] reader result",
              String(dataUrl).slice(0, 32)
            );
            setSelectedImageSrc(dataUrl);
            setIsCropping(true);
          };
          img.onerror = () => {
            console.error("[AvatarUpload] failed to load image for size check");
            if (fileInputRef.current) fileInputRef.current.value = "";
          };
          img.src = dataUrl;
        };
        reader.readAsDataURL(file);
      } catch (error) {
        console.error("[AvatarUpload] Error reading image file:", error);
      }
    }
  };

  const handleCropComplete = async (croppedDataUrl) => {
    console.log(
      "[AvatarUpload] crop complete, dataURL length",
      croppedDataUrl?.length
    );
    try {
      setIsUploading(true);
      const response = await fetch(croppedDataUrl);
      const blob = await response.blob();
      const file = new File([blob], "avatar.png", { type: "image/png" });
      console.log(
        "[AvatarUpload] uploading file",
        file.name,
        file.type,
        file.size
      );

      const uploadedUrl = await api.uploadImage(file);
      console.log("[AvatarUpload] uploaded URL", uploadedUrl);

      onImageChange(uploadedUrl);
      console.log("[AvatarUpload] onImageChange invoked");
    } catch (error) {
      console.error("[AvatarUpload] Error uploading cropped image:", error);
    } finally {
      setIsUploading(false);
      setIsCropping(false);
      setSelectedImageSrc(null);
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    }
  };

  return (
    <div className="avatar-upload">
      <label>Фото профиля</label>
      <div className="avatar-preview" style={{ position: "relative" }}>
        {currentImage && (
          <>
            <img src={currentImage} alt="Avatar" className="avatar-image" />
            <ClearImageButton
              onClick={() => {
                onImageChange("");
                console.log("Avatar cleared");
              }}
              title="Удалить аватар"
            />
          </>
        )}
      </div>
      
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileSelect}
        accept="image/*"
        style={{ display: "none" }}
      />
      <button
        className="upload-btn"
        onClick={() => fileInputRef.current?.click()}
        disabled={isUploading}
      >
        {isUploading
          ? "Загрузка..."
          : currentImage
          ? "Изменить фото"
          : "Загрузить фото"}
      </button>

      {isCropping && (
        <ImageCropper
          initialSrc={selectedImageSrc}
          onCropComplete={handleCropComplete}
          onCancel={() => {
            console.log("[AvatarUpload] crop cancelled");
            setIsCropping(false);
            setSelectedImageSrc(null);
            if (fileInputRef.current) {
              fileInputRef.current.value = "";
            }
          }}
        />
      )}
    </div>
  );
};

export default AvatarUpload;
